import styled from "styled-components";

import Button from "core/Button";
import SectionContainer from "core/SectionContainer";
import { OuterContainer } from "core/SectionContainer/styles";

import { convertPxToRem } from "frontend/components/helpers";
import breakpoints from "core/breakpoints";

const FOOTER_BOX_SHADOW = `0px -${convertPxToRem({ px: 4 })} ${convertPxToRem({
    px: 4
})} rgba(0, 0, 0, 0.15)`;

const FOOTER_HEIGHT_DESKTOP = 128;
const FOOTER_HEIGHT_TABLET = 120;

export const CtaContainer = styled.div`
    margin-top: ${convertPxToRem({ px: 32 })};

    ${Button} {
        margin-right: ${convertPxToRem({ px: 24 })};
    }
`;

export const PhotoUploadFooterSectionContainer = styled(SectionContainer).attrs(
    {
        topSpacing: "2xl",
        bottomSpacing: "2xl"
    }
)`
    box-shadow: ${FOOTER_BOX_SHADOW};
    height: ${convertPxToRem({ px: FOOTER_HEIGHT_DESKTOP })};

    ${OuterContainer} {
        position: sticky;
        width: 100%;
    }

    /* Tablet: */
    @media (min-width: ${breakpoints.tablet.rem}) and (max-width: ${breakpoints
            .beforeDesktop.rem}) {
        height: ${convertPxToRem({ px: FOOTER_HEIGHT_TABLET })};
    }
`;
